import React from 'react';

function Loader(props) {
    return (
        <div>
            <div className="progress">
                <div className="indeterminate"></div>
            </div>

        </div>
    );
}

export default Loader;